export default function keyInObj(value, key, obj) {
  return key in obj;
}
